import theme from '@/theme';
import { IVoice, Providers } from '@d-id/types';
import Tooltip from '@mui/material/Tooltip';
import { ReactNode } from 'react';

// it should be same as in backend
const supportedVoices: { language: string; locale: string }[] = [
    { language: 'Arabic', locale: 'ar-SA' },
    { language: 'Bulgarian', locale: 'bg-BG' },
    { language: 'Chinese', locale: 'zh-CN' },
    { language: 'Croatian', locale: 'hr-HR' },
    { language: 'Czech', locale: 'cs-CZ' },
    { language: 'Danish', locale: 'da-DK' },
    { language: 'Dutch', locale: 'nl-NL' },
    { language: 'English', locale: 'en-US' },
    { language: 'Filipino', locale: 'fil-PH' },
    { language: 'Finnish', locale: 'fi-FI' },
    { language: 'French', locale: 'fr-FR' },
    { language: 'German', locale: 'de-DE' },
    { language: 'Greek', locale: 'el-GR' },
    { language: 'Hindi', locale: 'hi-IN' },
    { language: 'Indonesian', locale: 'id-ID' },
    { language: 'Italian', locale: 'it-IT' },
    { language: 'Japanese', locale: 'ja-JP' },
    { language: 'Korean', locale: 'ko-KR' },
    { language: 'Malay', locale: 'ms-MY' },
    { language: 'Polish', locale: 'pl-PL' },
    { language: 'Portuguese', locale: 'pt-PT' },
    { language: 'Romanian', locale: 'ro-RO' },
    { language: 'Russian', locale: 'ru-RU' },
    { language: 'Slovak', locale: 'sk-SK' },
    { language: 'Spanish', locale: 'es-ES' },
    { language: 'Swedish', locale: 'sv-SE' },
    { language: 'Tamil', locale: 'ta-IN' },
    { language: 'Turkish', locale: 'tr-TR' },
    { language: 'Ukrainian', locale: 'uk-UA' },
];

export const ELEVEN_LABS_LANGUAGES = supportedVoices.map(voice => voice.language);

export const ELEVEN_LABS_LOCALES = supportedVoices.map(voice => voice.locale);

export const getVoiceInfo = (voice: IVoice): ReactNode => {
    if (voice.provider === Providers.Amazon) {
        return [voice.language, 'Multiple styles'].join(' · ');
    }

    if (voice.provider === Providers.Elevenlabs) {
        const infoArray = [];
        const isMultilingual = voice.language === 'multilingual';

        if (isMultilingual) {
            infoArray.push(`${ELEVEN_LABS_LANGUAGES.length} Languages`);
        } else {
            infoArray.push(voice.language);
        }

        if (voice?.accent) {
            const isAmericanAccent = voice.accent === 'american';

            if (isAmericanAccent) {
                infoArray[0] = infoArray[0] + ' (United States)';
            } else {
                const accent = voice.accent;
                const capitalized = accent.charAt(0).toUpperCase() + accent.slice(1);

                infoArray[0] = infoArray[0] + ` (${capitalized})`;
            }
        }

        if (voice?.description) {
            const description = voice?.description;
            const capitalized = description.charAt(0).toUpperCase() + description.slice(1);

            infoArray.push(capitalized);
        }

        const textToDisplay = infoArray.join(' · ');

        return isMultilingual ? (
            <Tooltip
                title={ELEVEN_LABS_LANGUAGES.join(', ')}
                slotProps={{ tooltip: { sx: { backgroundColor: theme.colors.secondary[900], padding: '8px', fontSize: '14px' } } }}>
                <div>{textToDisplay}</div>
            </Tooltip>
        ) : (
            textToDisplay
        );
    }

    return voice.language;
};
